import { pickNonNull } from '../pick-non-null.js';

/**
 * GET /organisations
 * @param {Object} params
 * @param {String} params.user
 */
export function getAll(params) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'get',
    url: `/organisations`,
    headers: { Accept: 'application/json' },
    queryParams: pickNonNull(params, ['user']),
    // no body
  });
}

/**
 * POST /organisations
 * @param {Object} params
 * @param {Object} body
 */
export function create(params, body) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'post',
    url: `/organisations`,
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    // no query params
    body,
  });
}

/**
 * DELETE /organisations/{id}
 * DELETE /self
 * @param {Object} params
 * @param {String} params.id
 */
export function remove(params) {
  const urlBase = params.id == null ? '/self' : `/organisations/${params.id}`;
  return Promise.resolve({
    method: 'delete',
    url: `${urlBase}`,
    headers: { Accept: 'application/json' },
    // no query params
    // no body
  });
}

/**
 * GET /organisations/{id}
 * GET /self
 * @param {Object} params
 * @param {String} params.id
 */
export function get(params) {
  const urlBase = params.id == null ? '/self' : `/organisations/${params.id}`;
  return Promise.resolve({
    method: 'get',
    url: `${urlBase}`,
    headers: { Accept: 'application/json' },
    // no query params
    // no body
  });
}

/**
 * PUT /organisations/{id}
 * PUT /self
 * @param {Object} params
 * @param {String} params.id
 * @param {Object} body
 */
export function update(params, body) {
  const urlBase = params.id == null ? '/self' : `/organisations/${params.id}`;
  return Promise.resolve({
    method: 'put',
    url: `${urlBase}`,
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    // no query params
    body,
  });
}

/**
 * PUT /organisations/{id}/avatar
 * PUT /self/avatar
 * @param {Object} params
 * @param {String} params.id
 * @param {Object} body
 */
export function updateAvatar(params, body) {
  const urlBase = params.id == null ? '/self' : `/organisations/${params.id}`;
  return Promise.resolve({
    method: 'put',
    url: `${urlBase}/avatar`,
    headers: { Accept: 'application/json', 'Content-Type': 'image/bmp' },
    // no query params
    body,
  });
}

/**
 * GET /organisations/{id}/consumptions
 * GET /self/consumptions
 * @param {Object} params
 * @param {String} params.id
 * @param {String} params.appId
 * @param {String} params.from
 * @param {String} params.to
 * @param {String} params.for
 */
export function getConsumptions(params) {
  const urlBase = params.id == null ? '/self' : `/organisations/${params.id}`;
  return Promise.resolve({
    method: 'get',
    url: `${urlBase}/consumptions`,
    headers: { Accept: 'application/json' },
    queryParams: pickNonNull(params, ['appId', 'from', 'to', 'for']),
    // no body
  });
}

/**
 * GET /organisations/{id}/credits
 * GET /self/credits
 * @param {Object} params
 * @param {String} params.id
 */
export function getCredits(params) {
  const urlBase = params.id == null ? '/self' : `/organisations/${params.id}`;
  return Promise.resolve({
    method: 'get',
    url: `${urlBase}/credits`,
    headers: { Accept: 'application/json' },
    // no query params
    // no body
  });
}

/**
 * GET /organisations/{id}/deployments
 * @param {Object} params
 * @param {String} params.id
 * @param {String} params.limit
 */
export function getAllDeployments(params) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'get',
    url: `/organisations/${params.id}/deployments`,
    headers: { Accept: 'application/json' },
    queryParams: pickNonNull(params, ['limit']),
    // no body
  });
}

/**
 * GET /organisations/{id}/instances
 * GET /self/instances
 * @param {Object} params
 * @param {String} params.id
 */
export function getAllInstances(params) {
  const urlBase = params.id == null ? '/self' : `/organisations/${params.id}`;
  return Promise.resolve({
    method: 'get',
    url: `${urlBase}/instances`,
    headers: { Accept: 'application/json' },
    // no query params
    // no body
  });
}

/**
 * GET /organisations/{id}/members
 * @param {Object} params
 * @param {String} params.id
 */
export function getAllMembers(params) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'get',
    url: `/organisations/${params.id}/members`,
    headers: { Accept: 'application/json' },
    // no query params
    // no body
  });
}

/**
 * POST /organisations/{id}/members
 * @param {Object} params
 * @param {String} params.id
 * @param {String} params.invitationKey
 * @param {Object} body
 */
export function addMember(params, body) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'post',
    url: `/organisations/${params.id}/members`,
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    queryParams: pickNonNull(params, ['invitationKey']),
    body,
  });
}

/**
 * DELETE /organisations/{id}/members/{userId}
 * @param {Object} params
 * @param {String} params.id
 * @param {String} params.userId
 */
export function removeMemeber(params) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'delete',
    url: `/organisations/${params.id}/members/${params.userId}`,
    headers: { Accept: 'application/json' },
    // no query params
    // no body
  });
}

/**
 * PUT /organisations/{id}/members/{userId}
 * @param {Object} params
 * @param {String} params.id
 * @param {String} params.userId
 * @param {Object} body
 */
export function updateMember(params, body) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'put',
    url: `/organisations/${params.id}/members/${params.userId}`,
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    // no query params
    body,
  });
}

/**
 * GET /organisations/{id}/payment-info
 * GET /self/payment-info
 * @param {Object} params
 * @param {String} params.id
 */
export function getPaymentInfo(params) {
  const urlBase = params.id == null ? '/self' : `/organisations/${params.id}`;
  return Promise.resolve({
    method: 'get',
    url: `${urlBase}/payment-info`,
    headers: { Accept: 'application/json' },
    // no query params
    // no body
  });
}

/**
 * GET /organisations/{id}/payments/billings
 * @param {Object} params
 * @param {String} params.id
 */
export function todo_getInvoices(params) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'get',
    url: `/organisations/${params.id}/payments/billings`,
    headers: { Accept: 'application/json' },
    // no query params
    // no body
  });
}

/**
 * POST /organisations/{id}/payments/billings
 * @param {Object} params
 * @param {String} params.id
 * @param {Object} body
 */
export function todo_buyDrops(params, body) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'post',
    url: `/organisations/${params.id}/payments/billings`,
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    // no query params
    body,
  });
}

/**
 * GET /organisations/{id}/payments/billings/unpaid
 * @param {Object} params
 * @param {String} params.id
 */
export function todo_getUnpaidInvoices(params) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'get',
    url: `/organisations/${params.id}/payments/billings/unpaid`,
    headers: { Accept: 'application/json' },
    // no query params
    // no body
  });
}

/**
 * DELETE /organisations/{id}/payments/billings/{bid}
 * DELETE /self/payments/billings/{bid}
 * @param {Object} params
 * @param {String} params.id
 * @param {String} params.bid
 */
export function deletePurchaseOrder(params) {
  const urlBase = params.id == null ? '/self' : `/organisations/${params.id}`;
  return Promise.resolve({
    method: 'delete',
    url: `${urlBase}/payments/billings/${params.bid}`,
    headers: { Accept: 'application/json' },
    // no query params
    // no body
  });
}

/**
 * GET /organisations/{id}/payments/billings/{bid}
 * GET /self/payments/billings/{bid}
 * @param {Object} params
 * @param {String} params.id
 * @param {String} params.bid
 */
export function getInvoice(params) {
  const urlBase = params.id == null ? '/self' : `/organisations/${params.id}`;
  return Promise.resolve({
    method: 'get',
    url: `${urlBase}/payments/billings/${params.bid}`,
    headers: { Accept: 'application/json' },
    // no query params
    // no body
  });
}

/**
 * PUT /organisations/{id}/payments/billings/{bid}
 * PUT /self/payments/billings/{bid}
 * @param {Object} params
 * @param {String} params.id
 * @param {String} params.bid
 * @param {Object} body
 */
export function choosePaymentProvider(params, body) {
  const urlBase = params.id == null ? '/self' : `/organisations/${params.id}`;
  return Promise.resolve({
    method: 'put',
    url: `${urlBase}/payments/billings/${params.bid}`,
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    // no query params
    body,
  });
}

/**
 * GET /organisations/{id}/payments/billings/{bid}.pdf
 * @param {Object} params
 * @param {String} params.id
 * @param {String} params.bid
 * @param {String} params.token
 */
export function todo_getPdfInvoice(params) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'get',
    url: `/organisations/${params.id}/payments/billings/${params.bid}.pdf`,
    headers: { Accept: 'application/pdf' },
    queryParams: pickNonNull(params, ['token']),
    // no body
  });
}

/**
 * GET /organisations/{id}/payments/fullprice/{price}
 * @param {Object} params
 * @param {String} params.id
 * @param {String} params.price
 */
export function todo_priceWithTax(params) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'get',
    url: `/organisations/${params.id}/payments/fullprice/${params.price}`,
    headers: { Accept: 'application/json' },
    // no query params
    // no body
  });
}

/**
 * GET /organisations/{id}/payments/methods
 * @param {Object} params
 * @param {String} params.id
 */
export function todo_getPaymentMethods(params) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'get',
    url: `/organisations/${params.id}/payments/methods`,
    headers: { Accept: 'application/json' },
    // no query params
    // no body
  });
}

/**
 * POST /organisations/{id}/payments/methods
 * @param {Object} params
 * @param {String} params.id
 * @param {Object} body
 */
export function todo_addPaymentMethod(params, body) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'post',
    url: `/organisations/${params.id}/payments/methods`,
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    // no query params
    body,
  });
}

/**
 * GET /organisations/{id}/payments/methods/default
 * @param {Object} params
 * @param {String} params.id
 */
export function todo_getDefaultMethod(params) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'get',
    url: `/organisations/${params.id}/payments/methods/default`,
    headers: { Accept: 'application/json' },
    // no query params
    // no body
  });
}

/**
 * PUT /organisations/{id}/payments/methods/default
 * @param {Object} params
 * @param {String} params.id
 * @param {Object} body
 */
export function todo_setDefaultMethod(params, body) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'put',
    url: `/organisations/${params.id}/payments/methods/default`,
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    // no query params
    body,
  });
}

/**
 * DELETE /organisations/{id}/payments/methods/{mId}
 * @param {Object} params
 * @param {String} params.id
 * @param {String} params.mId
 */
export function todo_deletePaymentMethod(params) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'delete',
    url: `/organisations/${params.id}/payments/methods/${params.mId}`,
    headers: {},
    // no query params
    // no body
  });
}

/**
 * GET /organisations/{id}/payments/monthlyinvoice
 * GET /self/payments/monthlyinvoice
 * @param {Object} params
 * @param {String} params.id
 */
export function getMonthlyInvoice(params) {
  const urlBase = params.id == null ? '/self' : `/organisations/${params.id}`;
  return Promise.resolve({
    method: 'get',
    url: `${urlBase}/payments/monthlyinvoice`,
    headers: { Accept: 'application/json' },
    // no query params
    // no body
  });
}

/**
 * PUT /organisations/{id}/payments/monthlyinvoice/maxcredit
 * @param {Object} params
 * @param {String} params.id
 * @param {Object} body
 */
export function todo_setMaxCreditsPerMonth(params, body) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'put',
    url: `/organisations/${params.id}/payments/monthlyinvoice/maxcredit`,
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    // no query params
    body,
  });
}

/**
 * DELETE /organisations/{id}/payments/recurring
 * @param {Object} params
 * @param {String} params.id
 */
export function todo_deleteRecurrentPayment(params) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'delete',
    url: `/organisations/${params.id}/payments/recurring`,
    headers: { Accept: 'application/json' },
    // no query params
    // no body
  });
}

/**
 * GET /organisations/{id}/payments/recurring
 * @param {Object} params
 * @param {String} params.id
 */
export function todo_getRecurrentPayment(params) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'get',
    url: `/organisations/${params.id}/payments/recurring`,
    headers: { Accept: 'application/json' },
    // no query params
    // no body
  });
}

/**
 * GET /self/payments/billings
 * @param {Object} params
 */
export function todo_getInvoices_1() {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'get',
    url: `/self/payments/billings`,
    headers: { Accept: 'application/json' },
    // no query params
    // no body
  });
}

/**
 * POST /self/payments/billings
 * @param {Object} params
 * @param {Object} body
 */
export function todo_buyDrops_1(params, body) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'post',
    url: `/self/payments/billings`,
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    // no query params
    body,
  });
}

/**
 * GET /self/payments/billings/{bid}.pdf
 * @param {Object} params
 * @param {String} params.bid
 * @param {String} params.token
 */
export function todo_getPdfInvoice_1(params) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'get',
    url: `/self/payments/billings/${params.bid}.pdf`,
    headers: { Accept: 'application/pdf' },
    queryParams: pickNonNull(params, ['token']),
    // no body
  });
}

/**
 * GET /self/payments/fullprice/{price}
 * @param {Object} params
 * @param {String} params.price
 */
export function todo_priceWithTax_1(params) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'get',
    url: `/self/payments/fullprice/${params.price}`,
    headers: { Accept: 'application/json' },
    // no query params
    // no body
  });
}

/**
 * GET /self/payments/methods
 * @param {Object} params
 */
export function todo_getUserPaymentMethods() {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'get',
    url: `/self/payments/methods`,
    headers: { Accept: 'application/json' },
    // no query params
    // no body
  });
}

/**
 * POST /self/payments/methods
 * @param {Object} params
 * @param {Object} body
 */
export function todo_addPaymentMethod_1(params, body) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'post',
    url: `/self/payments/methods`,
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    // no query params
    body,
  });
}

/**
 * GET /self/payments/methods/default
 * @param {Object} params
 */
export function todo_getDefaultMethod_1() {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'get',
    url: `/self/payments/methods/default`,
    headers: { Accept: 'application/json' },
    // no query params
    // no body
  });
}

/**
 * PUT /self/payments/methods/default
 * @param {Object} params
 * @param {Object} body
 */
export function todo_setDefaultMethod_1(params, body) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'put',
    url: `/self/payments/methods/default`,
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    // no query params
    body,
  });
}

/**
 * DELETE /self/payments/methods/{mId}
 * @param {Object} params
 * @param {String} params.mId
 */
export function todo_deleteUserCard(params) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'delete',
    url: `/self/payments/methods/${params.mId}`,
    headers: { Accept: 'application/json' },
    // no query params
    // no body
  });
}

/**
 * PUT /self/payments/monthlyinvoice/maxcredit
 * @param {Object} params
 * @param {Object} body
 */
export function todo_setMaxCreditsPerMonth_1(params, body) {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'put',
    url: `/self/payments/monthlyinvoice/maxcredit`,
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    // no query params
    body,
  });
}

/**
 * DELETE /self/payments/recurring
 * @param {Object} params
 */
export function todo_deleteRecurrentPayment_1() {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'delete',
    url: `/self/payments/recurring`,
    headers: { Accept: 'application/json' },
    // no query params
    // no body
  });
}

/**
 * GET /self/payments/recurring
 * @param {Object} params
 */
export function todo_getRecurrentPayment_1() {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'get',
    url: `/self/payments/recurring`,
    headers: { Accept: 'application/json' },
    // no query params
    // no body
  });
}

/**
 * GET /self/payments/tokens/stripe
 * @param {Object} params
 */
export function todo_getStripeToken_1() {
  // no multipath for /self or /organisations/{id}
  return Promise.resolve({
    method: 'get',
    url: `/self/payments/tokens/stripe`,
    headers: { Accept: 'application/json' },
    // no query params
    // no body
  });
}
